export const BING_COUNTRIES = ['CN']; // Country code CN: China
export const BING = 'bing';
export const GOOGLE = 'google';

export const MAP_DIMENSION = { width: 1920, height: 880 };

export const MAP_SIZE = {
  SMALL: 'Small',
  MEDIUM: 'Medium',
  FULL: 'Full'
};
export type ThirdPartyMapType = typeof GOOGLE | typeof BING;
